import {ReactElement} from 'react'
import {useMediaQuery, useTheme} from '@material-ui/core'
import {useSubscriptionStatistics} from '../../hooks/useSubscriptionStatistics'
import {PaginationApi} from '../../../../../../../shared/hooks/usePagination'
import {Pagination} from '../../../../../../Common/Pagination'
import {LoadingLayout} from '../LoadingLayout'
import {ErrorLayout} from '../ErrorLayout'
import {TableDesktop} from '../TableDesktop'
import {TableMobile} from '../TableMobile'

type SubscriptionsTableProps = {
  accountId: number
  selectedDate: string
  paginationApi: PaginationApi
  isDefaultDate: boolean
}

export const SubscriptionsTable = (props: SubscriptionsTableProps): ReactElement => {
  const {accountId, selectedDate, paginationApi, isDefaultDate} = props

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const subscriptionStats = useSubscriptionStatistics(accountId, {paginationApi,selectedDate})

  if (subscriptionStats.loading) return <LoadingLayout />
  if (subscriptionStats.error || !subscriptionStats.data || subscriptionStats.data.count === 0) return <ErrorLayout scope='table' />

  paginationApi.sanitizeWith(subscriptionStats.data.count)

  const TableComponent = isMobile ? TableMobile : TableDesktop

  return (
    <TableComponent
      subscriptions={subscriptionStats.data.subscriptions}
      isDefaultDate={isDefaultDate}
    >
      <Pagination
        paginationApi={paginationApi}
        totalCount={subscriptionStats.data.count}
      />
    </TableComponent>
  )
}
